import {ProductManagementApiService} from './product-management-api.service';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PagedApiResponse, Store} from '../models/clare';

export interface SupplierNameApi {
  getSupplierName(supplierId: string): Observable<string>;
}

@Injectable({providedIn: 'root'})
export class StoreApiService extends ProductManagementApiService implements SupplierNameApi {
  controllerPath = '';

  constructor(protected override http: HttpClient) {
    super(http);
  }

  get(supplierId: string): Observable<Store> {
    const orgId = this.parseOrgId(supplierId);
    const url = this.getUrl();
    return this.GET<PagedApiResponse<Store>>(url, {...this.requestOptions(), params: {organization_id: orgId}}).pipe(
      map(resp => resp.result[0])
    );
  }

  getSupplierName(supplierId: string): Observable<string> {
    return this.get(supplierId).pipe(map(store => store.name));
  }

  protected override getUrl(path = '') {
    return `${environment.clareApiUrl}/stores${path}`;
  }

  private parseOrgId(supplierId: string): string {
    const match = supplierId.match(/\d+/);
    if (!match) {
      throw new Error(`Unable to parse the organization ID from ${supplierId}`);
    }
    return match[0];
  }
}
